import cn from 'classnames';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { icons } from 'src/configs/icons';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { setSelectedCategory } from 'src/store/app/actions';
import { MediaManager } from '../../../manager/MediaManager';
import { Button } from '../../common/Button';
import './styles.scss';

type Props = {
  settings: {
    priority: number;
    classes: string;
    name: string;
    src?: string;
  };
};

const BlogWidget: FC<Props> = ({ settings }) => {
  const { classes, name, src } = settings;
  const navigate = useNavigate();
  const blogUrl = process.env.REACT_APP_BLOG_URL as string;
  const _setSelectedCategory = useConnectedAction(setSelectedCategory);
  const blogIconUrl = MediaManager.getSrcFromMediaAssets(src ?? icons.blog, '/');
  const changeSelectedMenuItem = (item: string): void => {
    if (blogUrl) {
      window.open(blogUrl, '_blank', 'noopener,noreferrer');
    } else {
      navigate(`/${item}`);
      _setSelectedCategory(item);
    }
  };
  return (
    <Button className={cn(classes, 'blog-widget')} onClick={() => changeSelectedMenuItem(name)} icon={blogIconUrl}>
      Blog
    </Button>
  );
};
export default BlogWidget;
